module.exports = __webpack_public_path__ + "img/design_1.4ddf32e4.png";